import { render, staticRenderFns } from "./ChargebackDetail.vue?vue&type=template&id=134c6fcf&scoped=true&"
import script from "./ChargebackDetail.vue?vue&type=script&lang=js&"
export * from "./ChargebackDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackDetail.vue?vue&type=style&index=0&id=134c6fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c6fcf",
  null
  
)

export default component.exports